import { Record } from 'immutable';
import { EventCollisionInfoVendor } from './event-collision-info-vendor';

const EventCollisionInfoRecord = Record({
  create_party: null,
  id: '0_0',
  event_name: null,
  start_date: null,
  end_date: null,
  first_name: null,
  last_name: null,
  email: null,
  phone: null,
  fax: null,
  event_party_id: null,
  chain: null,
  brand: null,
  property_id: null,
  property_name: null,
  property_address: null,
  property_zip: null,
  property_city: null,
  property_state: null,
  property_country: null,
  agency_id: null,
  name: null,
  dba_name: null,
  line1: null,
  line2: null,
  line3: null,
  city: null,
  state: null,
  postal_code: null,
  country_code: null,
  event_reference_number: null,
  auto_generated_code: null,
  manually_added: null,
  subscriber: 'Y',
  client_first_name: null,
  client_last_name: null,
  client_email: null,
  client_phone: null,
  client_fax: null,
  client_name: null,
  client_id: null,
  client_line1: null,
  client_city: null,
  client_state: null,
  client_zip: null,
  action: null,
  user_id: null,
  ev_tmp_guid: null,
  edited_event_id: null,
  edited_agency_id: null,
  edited_vendor_code: null,
  event_city: null,
  event_state: null,
  event_country_code: null,
  vendors: [],
});

export class EventCollisionInfo extends EventCollisionInfoRecord {
  create_party: string;
  id: string;
  event_name: string;
  start_date: string;
  end_date: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  fax: string;
  event_party_id: string;
  chain: string;
  brand: string;
  property_id: string;
  property_name: string;
  property_address: string;
  property_zip: string;
  property_city: string;
  property_state: string;
  property_country: string;
  agency_id: string;
  name: string;
  dba_name: string;
  line1: string;
  line2: string;
  line3: string;
  city: string;
  state: string;
  postal_code: string;
  country_code: string;
  event_reference_number: string;
  auto_generated_code: string;
  manually_added: string;
  subscriber: string;
  client_first_name: string;
  client_last_name: string;
  client_email: string;
  client_phone: string;
  client_fax: string;
  client_name: string;
  client_id: string;
  client_line1: string;
  client_city: string;
  client_state: string;
  client_zip: string;
  action: string;
  user_id: string;
  ev_tmp_guid: string;
  edited_event_id: number;
  edited_agency_id: string;
  edited_vendor_code: string;
  event_city: string;
  event_state: string;
  event_country_code: string;

  vendors: EventCollisionInfoVendor[];
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-collision-info.ts